import React, { useEffect, useRef, useState } from "react";
import TrainingLogo from "../../../assets/images/training/training-logo.png";
import FloatingBanner from "../../../components/FloatingBanner";
import * as S from "./styled";
import FloatingKakaoIcon from "../../../assets/images/home/home-floating-kakao.png";
import AOS from "aos";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Training = () => {
  const entranceRef = useRef<HTMLDivElement>(null);
  const auditionRef = useRef<HTMLDivElement>(null);
  const licenseRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [activeSection, setActiveSection] = useState<
    "entrance" | "audition" | "license"
  >("license");

  const [scrollHeight, setScrollHeight] = useState<number>(180);

  const handleScroll = () => {
    if (
      wrapperRef.current &&
      entranceRef.current &&
      auditionRef.current &&
      licenseRef.current
    ) {
      const entranceRect = entranceRef.current.getBoundingClientRect();
      const auditionRect = auditionRef.current.getBoundingClientRect();
      const licenseRect = licenseRef.current.getBoundingClientRect();
      const wrapperRect = wrapperRef.current.getBoundingClientRect();

      if (
        licenseRect.top >= wrapperRect.top &&
        licenseRect.bottom > scrollHeight
      ) {
        setActiveSection("license");
      } else if (
        entranceRect.top >= wrapperRect.top &&
        entranceRect.bottom > scrollHeight
      ) {
        setActiveSection("entrance");
      } else {
        setActiveSection("audition");
      }
    }
  };

  useEffect(() => {
    const updateScrollHeight = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1024) {
        setScrollHeight(180);
      } else if (screenWidth >= 768) {
        setScrollHeight(160);
      } else {
        setScrollHeight(120);
      }
    };

    updateScrollHeight();
    window.addEventListener("resize", updateScrollHeight);

    return () => {
      window.removeEventListener("resize", updateScrollHeight);
    };
  }, []);

  const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const sectionPosition =
        ref.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - scrollHeight + 5,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      AOS.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>넵튠 댄스 스튜디오 | 셔플 풋워크 전문 학원</title>

        <meta
          name="description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />

        <meta
          name="keywords"
          content="넵튠, 넵튠 댄스, 넵튠 댄스 스튜디오, 셔플, 셔플댄스학원, 댄스자격증, 풋워크 수업, 국제실용댄스지도자협회, 국제실용댄스, 풋워크"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://neptunedance.com" />
        <meta
          property="og:image"
          content="http://neptunedance.com/og-image.png"
        />
      </Helmet>
      <S.TrainingWrapper ref={wrapperRef}>
        <S.TrainingNavList>
          <li
            onClick={() => {
              scrollToSection(licenseRef);
            }}
            className={activeSection === "license" ? "active" : ""}
          >
            전문 자격증반
          </li>
          <li
            onClick={() => {
              scrollToSection(entranceRef);
            }}
            className={activeSection === "entrance" ? "active" : ""}
          >
            입시반
          </li>
          <li
            onClick={() => {
              scrollToSection(auditionRef);
            }}
            className={activeSection === "audition" ? "active" : ""}
          >
            오디션반
          </li>
        </S.TrainingNavList>
        <S.TrainigTitleWrap>
          <div className="inner">
            <S.TrainigTitleContainer>
              <h4
                data-aos="fade-up"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                전문인 양성과정
              </h4>
            </S.TrainigTitleContainer>
          </div>
        </S.TrainigTitleWrap>
        <S.LicenseWrap ref={licenseRef}>
          <div className="inner">
            <S.LicenseContainer>
              <div className="title-area">
                <h4
                  data-aos="fade"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                  data-aos-delay={200}
                >
                  {" "}
                  전문 자격증반
                </h4>
                <div
                  data-aos="fade-up"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                  data-aos-delay={400}
                >
                  <span>
                    넵튠 댄스 스튜디오는 국제실용댄스지도자협회 IPDIA의
                    서울본부로
                    <br />
                    {"  "}체계적인 교육 프로그램을 보유하고 있습니다.
                  </span>
                  <p>
                    연령과 성별 등의 제한이 없는 강사 양성을 비전으로 하며,
                    <br />
                    <br className="mobile" />
                    {"  "}특히 현장에서 필요로 하는 실질적인 기술과 지식을
                    <br className="mobile" />
                    {"  "}습득할 수 있도록 설계되어 있습니다.
                  </p>
                </div>
              </div>
              <div
                className="img-area"
                data-aos="fade"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <NavLink to="http://ipdiakorea.com/" target="_blank">
                  <i>
                    <img src={TrainingLogo} alt="training logo" />
                  </i>
                </NavLink>
              </div>
              <ul
                className="license-list"
                data-aos="fade-up"
                data-aos-duration={500}
                data-aos-easing="linear"
                data-aos-delay={200}
              >
                <li>
                  <span>01</span>
                  <p>전문성이 강화된 자격증 취득</p>
                </li>
                <li>
                  <span>02</span>
                  <p>다양한 댄스장르의 인재 양성</p>
                </li>
              </ul>
            </S.LicenseContainer>
          </div>
        </S.LicenseWrap>
        <S.EntranceWrap ref={entranceRef}>
          <div className="inner">
            <S.EntranceContainer>
              <div className="title-area">
                <h4
                  data-aos="fade"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                  data-aos-delay={200}
                >
                  입시반
                </h4>
                <div
                  data-aos="fade-up"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                  data-aos-delay={400}
                >
                  <span>
                    넵튠의 입시 시스템은 ‘댄스’를 직업으로 준비하는 학생들을
                    위한 집중 프로그램입니다.
                  </span>
                  <p>
                    전문 강사진의 지도하에 기본기부터 레벨업까지 체계적으로
                    <br />
                    <br className="mobile" />
                    {"  "}트레이닝하며,
                    <br />
                    {"  "}직업인으로서 본인만의 스타일을 구축할 수 있도록
                    <br className="mobile" />
                    <br />
                    {"  "}다양한 장르수업 경험 및 상담을 통해
                    <br className="mobile" /> {"  "}개인 맞춤 선생님을
                    배정합니다.
                  </p>
                </div>
              </div>
              <ul
                className="list-area"
                data-aos="fade"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <li>
                  <span>01</span>
                  <p>
                    기초체력 & 기본기
                    <br />
                    집중 트레이닝{" "}
                  </p>
                </li>
                <li>
                  <span>02</span>
                  <p>
                    다양한 댄스 장르
                    <br />
                    경험 및 흡수
                  </p>
                </li>
                <li>
                  <span>03</span>
                  <p>
                    입시 작품
                    <br />
                    트레이닝{" "}
                  </p>
                </li>
                <li>
                  <span>04</span>
                  <p>
                    입시 전략 및<br />
                    멘토링{" "}
                  </p>
                </li>
                <li>
                  <span>05</span>
                  <p>
                    실기 대비
                    <br />
                    중간평가 &<br />
                    전문인 피드백
                  </p>
                </li>
              </ul>
            </S.EntranceContainer>
          </div>
        </S.EntranceWrap>
        <S.AuditionWrap ref={auditionRef}>
          <div className="inner">
            <S.AuditionContainer>
              <div className="title-area">
                <h4
                  data-aos="fade"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                  data-aos-delay={200}
                >
                  오디션반
                </h4>
                <div
                  data-aos="fade-up"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                  data-aos-delay={400}
                >
                  <span>
                    넵튠의 오디션 준비반은 합격생을 다수 배출한 강사진이 직접
                    지도하는 체계적 프로그램입니다.
                  </span>
                  <p>
                    엔터 출강 및 오디션 트레이닝 경력이 풍부한 전문 강사진이
                    <br className="mobile" />
                    {"  "}직접 지도하며,
                    <br />
                    {"  "}오디션 합격을 위한 개인별 맞춤 상담,{" "}
                    <br className="mobile" />
                    {"  "}실력 성장 프로그램,
                    <br />
                    {"  "}비주얼디렉팅, 집중 피드백 수업으로
                    <br className="mobile" />
                    {"  "} 체계적으로 진행됩니다.
                  </p>
                </div>
              </div>
              <ul
                className="list-area"
                data-aos="fade"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <li>
                  <span>01</span>
                  <p>
                    기본기
                    <br />
                    집중 트레이닝
                  </p>
                </li>
                <li>
                  <span>02</span>
                  <p>오디션을 위한 작품 수업</p>
                  <span className="sub-text">
                    실력과 준비기간에 따른
                    <br />
                    개인,단체별 수업
                  </span>
                </li>
                <li>
                  <span>03</span>
                  <p>비주얼 디렉팅</p>
                </li>
                <li>
                  <span>04</span>
                  <p>
                    전문 강사진의
                    <br />
                    맞춤형 개별 피드백{" "}
                  </p>
                </li>
              </ul>
            </S.AuditionContainer>
          </div>
        </S.AuditionWrap>

        <FloatingBanner
          linkTo="http://pf.kakao.com/_xdxcJZn"
          icon={FloatingKakaoIcon}
          text="상담 문의"
          target="_blank"
        />
      </S.TrainingWrapper>
    </>
  );
};

export default Training;
